export function buildListingQuoteHref(input: {
  slug: string;
  quantity: number;
  preferredDate: string;
}) {
  const params = new URLSearchParams({
    qty: String(input.quantity),
    deliveryDate: input.preferredDate,
  });
  return `/listing/${input.slug}/request-quote?${params.toString()}`;
}
